import { HonestSelectInput } from '../../../components/HonestSelect/HonestSelectInput'
import { Input } from '../../../components/Input/Input'
import { Animation, Box, Button, ButtonsContainer, Flex, H2, ItemsGrid, OrangeCircle, SquareIcon, TabFooter, ThinSeparator } from '../../../styling/GlobalStyles'
import { useDispatch, useSelector } from 'react-redux'
import { CancelBtn } from 'components/Button/CancelBtn'
import { getSingleInventoryCategory } from 'features/inventory/invSettingsCategoriesSlice'
import { AppDispatch, RootState } from 'store'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { INameId, ISelectValue } from 'constants/globalTypes'
import { standardFieldValidation, validateSelect } from 'utils/validationUtils'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { useEffect } from 'react'
import { IItemsTab, ISingleInventoryCategory } from 'types/inventory.interface'
import { AddProfileImage, AddProfileImageClick, AddProfileImageInput } from 'pages/Employees/AddEmployee.styled'
import Avatar from '../../../assets/images/profileAvatar.png'
import { getBase64 } from 'utils/helpers'
import { addImagePlus } from 'assets/icons/AddImagePlus'
import { itemsValidationList } from './itemsValidation'
import { BodyText, TitleText } from 'styling/Typography'
import { PlusIcon } from 'assets/icons/PlusIcon'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { barCodeTypes } from './itemsData'
import styled from 'styled-components'

export const InventoryItemsSpecificationTab = ({
  state,
  setState,
  setActive,
  invalidFields,
  setInvalidFields,
}: IItemsTab) => {
  const dispatch = useDispatch<AppDispatch>()
  const { singleInventoryCategory } = useSelector((state: RootState) => state.inventoryCategories)

  useEffect(() => {
    state?.category?.value && dispatch(getSingleInventoryCategory(state?.category?.value)).then(d => {
      setState(prev => {
        const copy = structuredClone(prev)
        let fields = copy?.fields

        const missingFields = (d.payload as ISingleInventoryCategory)?.fields.map(f => ({ ...f, value: null })).filter(f => !state?.fields.some(sf => sf.field?.id == f?.field?.id)).map(f => ({ ...f, id: f?.field?.id }))
        try {
          if (missingFields?.length) {
            fields = [...fields, ...missingFields]
          }
        } catch (error) {
          console.log(error)
        }
        copy.fields = fields

        return copy
      })

    })
  }, [state?.category?.value])
  useFocusFirstInput()

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    if (itemsValidationList.includes(name)) {
      standardFieldValidation(e, setInvalidFields)
    }
    setState((prev) => ({ ...prev, [name]: value }))
  }


  const handleSelect = async (value: ISelectValue, name: string) => {
    if (itemsValidationList.includes(name)) {
      validateSelect(value, name, setInvalidFields)
    }
    const copy = structuredClone(state)
    copy[name] = value
    if (name == 'category') {
      if (value.value) {
        await dispatch(getSingleInventoryCategory(value.value)).then(d => {
          let fields = []

          const missingFields = (d.payload as ISingleInventoryCategory)?.fields.map(f => ({ ...f, value: null })).filter(f => !state?.fields?.some(sf => sf.field?.id == f?.field?.id)).map(f => ({ ...f, id: f?.field?.id }))
          try {
            if (missingFields?.length) {
              fields = [...fields, ...missingFields]
            }
          } catch (error) {
            console.log(error)
          }
          copy.fields = fields
        })
      } else {
        copy.fields = []
      }
    }
    setState(copy)
  }


  const handleImage = (e) => {
    e.target.parentElement.children[1].click()
  }


  const handleSelectField = (value: ISelectValue, id: number) => {
    const newState = structuredClone(state)
    const fieldIndex = newState?.fields?.findIndex((f) => f.id == id)
    if (fieldIndex > -1) {
      newState.fields[fieldIndex].value = value.value
    } else {
      const fields = (singleInventoryCategory as any)?.fields.find(f => f.id == id)
      newState.fields.push({ ...fields, value: value.value })
    }
    // newState.fields.map((item) => ({ id: item.id, value: item.value }))
    setState(newState)
  }

  const handleInputField = (e: React.FormEvent<HTMLInputElement>) => {
    const { value, id, type } = e.target as HTMLInputElement
    const newState = structuredClone(state)
    const objIndex = newState.fields.findIndex((item) => Number(item.id) == Number(id))
    if (objIndex > -1) {
      newState.fields[objIndex].value = type === 'number' ? Number(value) : value
    } else {
      const field = (singleInventoryCategory as any)?.fields.find(f => f.id == id)
      newState.fields.push({ ...field, value })
    }
    setState(newState)
  }

  const renderFields = () => {
    const forReturn = state?.fields?.map((field) => {
      if (field.field?.dataType == 1) {
        return (
          <Input
            id={field.id}
            key={singleInventoryCategory?.id + '-' + field.id}
            name={field.field.label}
            value={field.value}
            type='text'
            labelText={field.field.label}
            onChange={handleInputField}
            placeholder={'Enter text ' + field.field.label}
          />
        )
      } else if (field.field?.dataType == 2) {
        const getValue = () => {
          const foundField = state.fields.find((f) => f.id == field.id)
          return foundField ? foundField.value : ''
        }

        return (
          <Input
            id={field.id}
            key={singleInventoryCategory?.id + '-' + field.id}
            name={field.field.label}
            value={getValue()}
            type='number'
            labelText={field.field.label}
            onChange={handleInputField}
            placeholder={'Enter ' + field.field.label}
          />
        )
      } else {
        const optionsForSelect = field.field?.dropDownItems?.map((item) => ({ label: item.name, value: item.id })) || []

        const defaultValue = () => {
          const foundOption = field.field?.dropDownItems?.find((o) =>
            typeof field.value === 'object' ? o?.id === field?.value?.id : o?.id === field?.value,
          )
          return foundOption?.id
        }

        return (
          <HonestSelectInput
            key={singleInventoryCategory?.id + '-' + field?.id}
            name={field?.id?.toString()}
            onChange={(value: ISelectValue) => handleSelectField(value, field?.id)} // ovde id
            labelText={field?.field?.label}
            defaultValue={defaultValue()}
            options={optionsForSelect}
            noX
          />
        )
      }
    })

    return forReturn
  }


  const parseCategories = (data: any) => {
    return data ? data.data.map((item: any) => ({ label: item.name, value: item.id, disabled: (!item.parent || typeof item.parent === 'object'), suboptions: item.subcategories?.map((o: INameId) => ({ value: o.id, label: o.name })) || [] })) : []
  }

  const handleNext = () => {
    setActive('Replenishment')
  }

  const removeBarCode = (id: number) => {
    setState(prev => ({ ...prev, barcodes: prev.barcodes?.filter(b => b.id !== id) }))
  }


  const addBarcode = () => {
    setState(prev => ({
      ...prev, barcodes: [...(prev.barcodes || []), {
        id: new Date().getMilliseconds(),
        code: '', type: null, unit: null, quantity: null
      }]
    }))
  }

  const handleBarCode = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {
    const { value, valueAsNumber, name } = e.target
    const newState = structuredClone(state)
    const objIndex = newState.barcodes.findIndex((item) => item.id == id)
    if (objIndex > -1) {
      newState.barcodes[objIndex][name] = name == 'code' ? value : valueAsNumber
    }
    setState(newState)
  }

  const handleBarCodeSelect = (value: ISelectValue, name: string, id: number) => {
    const newState = structuredClone(state)
    const objIndex = newState.barcodes.findIndex((item) => item.id == id)
    if (objIndex > -1) {
      newState.barcodes[objIndex][name] = value
    }
    setState(newState)
  }

  const Wrapper = styled.div`
      display: flex;
      gap: 1rem;
      width: 100%;
      align-items: flex-start;

      @media (max-width: 1100px) {
        flex-direction:column;
        align-items: center;
      }
  `

  return (
    <Animation>
      <Wrapper>
        <AddProfileImage  >
          {state?.image ? (
            <>
              <AddProfileImageClick onClick={handleImage}>
                <OrangeCircle>
                  <img
                    src={state.image}
                    alt='profile-image'
                    onError={({ currentTarget }) => (currentTarget.src = Avatar)} // TODO
                  />
                </OrangeCircle>
                <H2 noUpperCase>Item Image</H2>
              </AddProfileImageClick>
              <AddProfileImageInput
                type='file'
                name='imageupload'
                accept='image/*'
                onChange={(e) => {
                  getBase64(e.target.files[0]).then((res: string) =>
                    setState((prev) => {
                      const copy = { ...prev }
                      copy.image = res
                      return copy
                    }),
                  )
                }}
              />
            </>
          ) : (
            <>
              <AddProfileImageClick onClick={handleImage}>
                <OrangeCircle>{addImagePlus}</OrangeCircle>
                <H2 noUpperCase>Add Item Image</H2>
              </AddProfileImageClick>
              <AddProfileImageInput
                type='file'
                name='imageupload'
                accept='image/*'
                onChange={(e) => {
                  getBase64(e.target.files[0]).then((res: string) =>
                    setState((prev) => {
                      const copy = { ...prev }
                      copy.image = res
                      return copy
                    }),
                  )
                }}
              />
            </>
          )}
        </AddProfileImage>
        <Flex column width='100%' >
          <ItemsGrid columns={3} gap='1rem'>
            <Input
              value={state?.name}
              name='name'
              onChange={handleChange}
              type='text'
              placeholder='Enter name'
              labelText='Item Name'
              invalid={invalidFields.includes('name') ? 'true' : ''}
              required
            />

            <Input
              value={state?.sku}
              name='sku'
              onChange={handleChange}
              type='text'
              placeholder='Enter SKU'
              labelText='SKU'
              invalid={invalidFields.includes('sku') ? 'true' : ''}
              required

            />

            <HonestSelectAsyncInput
              link='units'
              name='unit'
              labelText='Unit'
              placeholder='Select Unit'
              defaultValue={state?.unit?.label}
              onChange={handleSelect}
              parserFunction={(data: any) => data.map((i: any) => ({ label: i.name, value: i.id }))}
              invalid={invalidFields.includes('unit')}
              required

            />

            <HonestSelectAsyncInput
              link='inventory/category'
              placeholder='Search categories'
              name='category'
              labelText='Category'
              defaultValue={state?.category?.label}
              onChange={(value) => handleSelect(value, 'category')}
              parserFunction={parseCategories}
              invalid={invalidFields.includes('category')}
              required
              noX

            />
            {renderFields()}


          </ItemsGrid>
          <ThinSeparator />
          <Flex width='100%' between alignEnd >
            <Input
              textarea
              name='description'
              value={state?.description || ''}
              onChange={handleChange}
              type='textarea'
              placeholder='Enter description'
              labelText='Description'
              height='6rem'
              nomarg
              width='40%'
            />

          </Flex>


          <ThinSeparator />
          <Flex center gap='2rem' mb='16' >
            <TitleText weight='bold' >Barcodes:</TitleText>
            <SquareIcon style={{ marginTop: 16 }} onClick={addBarcode}  >
              {PlusIcon}
            </SquareIcon>
          </Flex>
          <ItemsGrid columns={3}>
            {state?.barcodes?.length ? state?.barcodes?.map((b, i) => <Box width='20rem' key={b.id} >
              <Flex column  >
                <Flex width='100%' between >
                  <TitleText weight='bold' >Bar Code {i + 1}</TitleText>
                  <CloseIcon onClick={() => removeBarCode(b.id)} />
                </Flex>
                <Input
                  type='text'
                  placeholder='123456789'
                  onChange={e => handleBarCode(e, b.id)}
                  name='code'
                  labelText='Code'
                  value={b.code}
                  required
                />
                <Input
                  type='number'
                  placeholder='15'
                  onChange={e => handleBarCode(e, b.id)}
                  name='quantity'
                  labelText='Quantity'
                  value={b.quantity}
                  required
                />

                <HonestSelectInput
                  onChange={(v, n) => handleBarCodeSelect(v as ISelectValue, n, b.id)}
                  options={barCodeTypes}
                  name='type'
                  defaultValue={b?.type?.value}
                  labelText='Type'
                  required
                />

                <HonestSelectAsyncInput
                  link='units'
                  name='unit'
                  labelText='Unit'
                  placeholder='Select Unit'
                  defaultValue={b?.unit?.label}
                  onChange={(v, n) => handleBarCodeSelect(v, n, b.id)}
                  parserFunction={(data: any) => data.map((i: any) => ({ label: i.name, value: i.id }))}
                  required
                />
              </Flex>
            </Box>) : <BodyText>No Barcodes</BodyText>}
          </ItemsGrid>
        </Flex>


      </Wrapper>

      <TabFooter >
        <ButtonsContainer>
          <CancelBtn />
          <Button orange onClick={handleNext}>
            Next
          </Button>
        </ButtonsContainer>
      </TabFooter>
    </Animation>
  )
}
